import { FeatureName } from '@faire/web-api--source/indigofair/data/FeatureName';
import { IConductorBuilderComponent } from '@faire/web-api--source/indigofair/data/IConductorBuilderComponent';
import { IConductorSDUIComponent } from '@faire/web-api--source/indigofair/data/IConductorSDUIComponent';

export namespace IConductorComponent {
  /**
   * Return an instance of IConductorComponent with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IConductorComponent>
  ): IConductorComponent =>
    ({
      child_component_feature_names: {},
      ...(partial ?? {}),
    }) as IConductorComponent;
}

export interface IConductorComponent {
  /**
   * @protobufOption (.faire.common.tokenType) = CONDUCTOR_COMPONENT
   */
  token: string | undefined;
  feature_name: keyof typeof FeatureName | undefined;
  /**
   * For rotating banners: maps child component IDs to their feature names
   * Key: component ID, Value: feature name string
   */
  child_component_feature_names: Partial<Record<string, string>>;
  sdui_component: IConductorSDUIComponent | undefined;
  builder_component: IConductorBuilderComponent | undefined;
}
